/**
 * 应用侧边栏导航
 */

import { Layout, Menu } from 'antd'
import {
  AlertOutlined,
  MonitorOutlined,
  SettingOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { useUIStore } from '@/store/useDeviceStore'

const { Sider } = Layout

function AppSider() {
  const navigate = useNavigate()
  const location = useLocation()
  const { siderCollapsed, toggleSider } = useUIStore()

  // 菜单项
  const menuItems = [
    {
      key: '/monitor',
      icon: <MonitorOutlined />,
      label: '实时监控',
    },
    // TODO: 历史回放功能暂未完善，暂时禁用
    // {
    //   key: '/history',
    //   icon: <HistoryOutlined />,
    //   label: '历史回放',
    // },
    {
      key: '/alarms',
      icon: <AlertOutlined />,
      label: '报警中心',
    },
    {
      key: '/videos',
      icon: <VideoCameraOutlined />,
      label: '视频管理',
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    },
  ]

  return (
    <Sider
      collapsible
      collapsed={siderCollapsed}
      onCollapse={toggleSider}
      width={200}
      style={{ overflow: 'hidden' }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
        style={{ marginTop: 16, maxHeight: 'calc(100% - 16px)', overflowY: 'auto' }}
      />
    </Sider>
  )
}

export default AppSider
